var map = {
	"./RoleImg/DataAnalysis.png": "cb3d",
	"./RoleImg/Engineering.png": "de30",
	"./RoleImg/ExhibitionServices.png": "640c",
	"./RoleImg/Financial.png": "1b22",
	"./RoleImg/FinancialManagement.png": "bbd3",
	"./RoleImg/LobbyRoom.png": "fd6c",
	"./RoleImg/Marketing.png": "4cd8",
	"./RoleImg/MiceMarketing.png": "7c84",
	"./RoleImg/ProjectManagement.png": "791e",
	"./RoleImg/Resources.png": "b278",
	"./RoleImg/Restaurant.png": "6694",
	"./RoleImg/administrator.png": "1a8f",
	"./RoleImg/沙盘精灵.png": "5739"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46e6";